
<template>
  <div class="top" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="top-t">
      <span class="f">全国道路排行 TOP150</span>
      <el-button
        v-for="(i,k) in btnData"
        :key="k"
        :class="k==btnIndex?'a-btn':''"
        @click="getData(k,i.name)"
        size="small"
      >{{i.name}}</el-button>
      <img width="18" src="../../../assets/images/year.png" />
      <span>年运营</span>
      <img width="18" src="../../../assets/images/day.png" />
      <span>日运营</span>
      <div class="ser" style="margin-left: 50px;">
        <el-input placeholder="请输入搜索道路编号如:G104" v-model="roadNo" clearable>
          <template  slot="append"><span style="color: #fff;">搜索</span> </template>
        </el-input>
        <div class="submit" @click="initData"></div>
      </div>
      <el-button class="close-btn" size="small" @click="goBack">关闭</el-button>
    </div>
    <div class="top-c">
      <div
        v-for="(i,k) in leftData"
        :key="k"
        :class="k==activeIndex?'a':''"
        @click="clickfun(i.id)"
        @mouseover="overFun(k)"
        @mouseout="outFun"
      >
        <div class="dot">{{k+1}}</div>
        <h5 v-html="i.highSpeedName"></h5>
        <div class="lb">
          <div :style="{width: i.percentage+'%',background:i.color}" class="gr"></div>
        </div>
        <div class="l-bot">
          <img width="18" src="../../../assets/images/year.png" />
          <span>{{i.yearOperate}}</span>
          <div>
            <img width="18" src="../../../assets/images/day.png" />
            <span>{{i.dayOperate}}</span>
          </div>
        </div>
      </div>
      <div v-if="leftData.length==0" style="color: rgb(255, 255, 255); display: flex; justify-content: center;align-items: center; width: 100%; height: 100%;">暂无相关道路信息</div>
    </div>
  </div>
</template>
 
<script>
import axios from '@/api/road.js'
import commonFun from '../assets/js/common.js'
export default {
  data() {
    return {
      btnData: [{ name: '全部' },{ name: '高速' }, { name: '国道' }, { name: '省道' }],
      roadType: '',
      roadNo:'',
      btnIndex: 0,
      loading: false,
      cityData: [],
      leftData: [],
      activeIndex: '-1'
    }
  },
  props: {},
  watch: {
    roadNo(o,n){
      if(o==''){
        this.initData()
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      var _this = this
      _this.leftData = []
      _this.loading = true
      axios.getAllRoad(this.roadNo,this.roadType).then(e => {
        if (e.data) {
          _this.leftData = commonFun.returnColor(e.data, true)
          _this.loading = false
        }
      })
    },
    clickfun(id) {
      let roadType = this.roadType==''?'全部':this.roadType ;
      // isChildLoad(roadType,id){
      this.$emit("isChildLoad",roadType,id)
      // this.$router.push({
      //   path: '/roadOperation/allRoad',
      //   query: { id: id, roadType: this.roadType }
      // })
    },
    getData(k, name) {
      this.btnIndex = k
      this.roadNo = ''
      this.roadType = name=='全部'?'':name
      this.initData()
    },
    goBack() {
       this.$parent.topRoadAll=false
      // this.$router.go(-1)
    },
    // 鼠标放上去事件
    overFun(i) {
      this.activeIndex = i
    },
    outFun() {
      this.activeIndex = -1
    },
  }
}
</script>